<template>
    <v-form @submit.prevent="save" novalidate class="elevation-2 pa-3">
      <tinymce :id="'tiny-' + (this.placeholder.id || 'new')" v-model="form.content" :other_options="otherOptions"></tinymce>

      <v-btn type="submit" color="primary">Zapisz</v-btn>
    </v-form>
</template>

<script>
import {createPlaceholder, updatePlaceholder} from './api'
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'
import _ from 'lodash'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import TinymceVue from '@/utils/TinymceVue'
import api from '@/utils/api'

export default {
  components: {
    'tinymce': TinymceVue
  },
  validators: {
    'form.content': function (value) {
      value = value || null
      return Validator.value(value).required().custom(serverValidation(this.formErrors, 'content'))
    }
  },
  props: {
    slug: {
      type: String,
      required: true
    },
    placeholder: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isUpdate: false,
      formErrors: {},
      form: {
      },
      otherOptions: {
        relative_urls: false,
        remove_script_host: true,
        convert_urls: true,
        images_upload_handler: function (blobInfo, success, failure) {
          let formData = new FormData()
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          api({
            method: 'POST',
            url: 'pages/uploads/',
            data: formData
          }).then((data) => {
            success(data.data.location)
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  created () {
    this.form = _.cloneDeep(this.placeholder)
    if (this.placeholder.id) {
      this.isUpdate = true
    }
  },
  methods: {
    save () {
      this.$validate().then(success => {
        if (success) {
          let promise
          if (this.isUpdate) {
            promise = updatePlaceholder(this.slug, this.form)
          } else {
            promise = createPlaceholder(this.slug, this.form)
            promise = promise.then((data) => {
              this.form = {}
              this.validation.reset()
              return data
            })
          }
          promise.then((data) => {
            this.$emit('success', data)
            iziToast.show({
              message: this.isUpdate ? 'Element został edytowany' : 'Element został dodany',
              color: 'green'
            })
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PlaceholderForm.vue